import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _Absenteeism, _AnnotationReport, _BodyMeasurements } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import { BasicButton } from "../../../theme/Component/BasicButton";

interface Props {
    dashedMenu?: boolean;
    idAccount?: number;
}

export const BodyMeasurements = ({ idAccount, dashedMenu }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_BodyMeasurements);

    const [modalAdd, setModalAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)
    const [account, setAccount] = useState<number>(null);


    useEffect(() => {
        getLista()
    }, [])

    const getLista = () => {
        const Props = {
            State: 1,
            IDAccount: account ? account : idAccount,
        }
        instance.getBodyMeasurementsCatalogPorPropiedadesRender(Props, null).then(
            (resp: any) => {
                let x = resp;
                x.forEach((user) => {
                    user.DataBeanProperties.NameAcc = (user.DataBeanProperties.Name1 ?? "") + "-" + (user.DataBeanProperties.Name2 ?? "") + "-" + (user.DataBeanProperties.Surname1 ?? "") + "-" + (user.DataBeanProperties.Surname2 ?? "");
                });
                setLista(x)
                if (dashedMenu && resp.length > 0) {
                    setBean(resp[0].DataBeanProperties)
                }
            }
        ).catch(err => toast.error("No se pudo cargar la información"))

    }



    const create = () => {
        setBean({
            State: 1,
            IDAccount: idAccount ? idAccount : null
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = (obj: any) => {
        instance.updateBodyMeasurements(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalAdd({ ...modalAdd, "view": false });
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        let x = { ...bean, State: 2 }
        editaItem(x);

    }

    const head = [
        { title: 'ID', property: 'IDBodyMeasurement', visible: true },
        { title: 'Funcionario', property: 'NameAcc', visible: true },
        { title: 'No Identificación', property: 'NitAccount', visible: true },
        { title: 'Talla Camisa', property: 'ShirtSizeName', visible: true },
        { title: 'Talla Pantalon', property: 'PantsSizeName', visible: true },
        { title: 'Talla Chaqueta', property: 'JacketSizeName', visible: true },
        { title: 'Tamaño de zapatos', property: 'BootsSizeName', visible: true },
        { title: 'Tamaño de bata', property: 'CoatSizeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: (_single.canCreate() || dashedMenu), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: (_single.canEdit() || dashedMenu), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: (_single.canDelete() || dashedMenu), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                {dashedMenu ?
                    <div className="row">
                        {!dashedMenu &&
                            <div className="col-md-6">
                                <AccountEditor label="Funcionario" idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                        }
                        <div className="col-md-6">
                            <label>Talla Camisa</label>
                            <SelectTHConstantsValue code={205} value={bean.ShirtSize} onChange={(e: any) => { setBean({ ...bean, "ShirtSize": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <label>Talla Pantalon</label>
                            <SelectTHConstantsValue code={206} value={bean.PantsSize} onChange={(e: any) => { setBean({ ...bean, "PantsSize": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <label>Talla Chaqueta</label>
                            <SelectTHConstantsValue code={207} value={bean.JacketSize} onChange={(e: any) => { setBean({ ...bean, "JacketSize": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <label>Talla Zapatos</label>
                            <SelectTHConstantsValue code={208} value={bean.BootsSize} onChange={(e: any) => { setBean({ ...bean, "BootsSize": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <label>Tamaño de bata</label>
                            <SelectTHConstantsValue code={209} value={bean.CoatSize} onChange={(e: any) => { setBean({ ...bean, "CoatSize": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-12 mt-2">
                            <BasicButton eventClick={() => { editaItem({ ...bean, IDAccount: idAccount, State: 1 }) }} icon="ri-save-line" children={`Guardar Información`} />
                        </div>

                    </div>
                    :
                    <BasicPage titulo="Tallas Funcionario">
                        <div className="row">
                            <div className="col-md-6">
                                <AccountEditor idAccount={account} onChange={(e) => { setAccount(e.IDAccount) }} label="Usuario" />
                            </div>
                            <div className="col-md-4 mt-4">
                                <BasicButton icon="ri-search-line" eventClick={getLista} >Buscar</BasicButton>
                            </div>
                            <div className="col-md-12">
                                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                            </div>
                        </div>
                    </BasicPage>
                }
                <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                    <>
                        <div className="row">
                            {!dashedMenu &&
                                <div className="col-md-6">
                                    <AccountEditor label="Funcionario" idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                            }
                            <div className="col-md-6">
                                <label>Talla Camisa</label>
                                <SelectTHConstantsValue code={205} value={bean.ShirtSize} onChange={(e: any) => { setBean({ ...bean, "ShirtSize": e }) }}></SelectTHConstantsValue>
                            </div>
                            <div className="col-md-6">
                                <label>Talla Pantalon</label>
                                <SelectTHConstantsValue code={206} value={bean.PantsSize} onChange={(e: any) => { setBean({ ...bean, "PantsSize": e }) }}></SelectTHConstantsValue>
                            </div>
                            <div className="col-md-6">
                                <label>Talla Chaqueta</label>
                                <SelectTHConstantsValue code={207} value={bean.JacketSize} onChange={(e: any) => { setBean({ ...bean, "JacketSize": e }) }}></SelectTHConstantsValue>
                            </div>
                            <div className="col-md-6">
                                <label>Talla Zapatos</label>
                                <SelectTHConstantsValue code={208} value={bean.BootsSize} onChange={(e: any) => { setBean({ ...bean, "BootsSize": e }) }}></SelectTHConstantsValue>
                            </div>
                            <div className="col-md-6">
                                <label>Tamaño de bata</label>
                                <SelectTHConstantsValue code={209} value={bean.CoatSize} onChange={(e: any) => { setBean({ ...bean, "CoatSize": e }) }}></SelectTHConstantsValue>
                            </div>


                        </div>

                    </>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div >
    )
}